// extracted by mini-css-extract-plugin
module.exports = {"body":"_404_body_BS1I3","view":"_404_view_lPEpm"};